var MessageTypes;
(function (MessageTypes) {
    MessageTypes[MessageTypes["TextOrEmoji"] = 0] = "TextOrEmoji";
    MessageTypes[MessageTypes["Gif"] = 1] = "Gif";
    MessageTypes[MessageTypes["QuickWord"] = 2] = "QuickWord";
})(MessageTypes || (MessageTypes = {}));

export { MessageTypes };
